import request from '@/utils/request'


// 网站卡片详情

export function siteCardInfo(data) {
  return request({
    url: '/website/card/info',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

// 网站卡片流量详情
export function siteCardFlow(data) {
  return request({
    url: '/website/card/flow',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}


// 网站查询卡历史套餐
export function siteCardProductHistory(data) {
  return request({
    url: '/website/card/productHistory',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

//网站查询卡历史短信套餐
export function siteCardSmsProductHistory(data) {
  return request({
    url: '/website/card/smsProductHistory',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

//网站查询卡历史语音套餐
export function siteCardVoiceProductHistory(data) {
  return request({
    url: '/website/card/voiceProductHistory',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

// 网站查询卡历史订单
export function siteCardOrderHistory(data) {
  return request({
    url: '/website/card/orderHistory',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}


// 网站查询卡组列表
export function siteCardGroupList(data) {
  return request({
    url: '/website/card/groupList',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

// 网站查询套餐列表
export function siteProductList(data) {
  return request({
    url: '/website/card/productList',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

// 网站查询套餐列表
export function siteNormalProductList(data) {
  return request({
    url: '/website/card/normalProductList',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

// 网站查询货币列表

export function siteCurrencyList(data) {
  return request({
    url: '/h5/international/currencyList',
    method: 'get',
    headers: {
      isToken: false
    },
    params: data
  })
}

export function siteInternationalPay(data) {
  return request({
    url: '/website/pay/order',
    method: 'post',
    headers: {
      isToken: false
    },
    data: data
  })
}












